import isServer from '../isServer';

var isIpadPro = function isIpadPro() {
  return /MacIntel/.test(navigator.platform) && 'ontouchend' in document;
};

var isIpadGeneral = function isIpadGeneral() {
  return /iPad|iPod/.test(navigator.userAgent);
};

var isIpad = function isIpad() {
  return !isServer() && (isIpadPro() || isIpadGeneral());
};

export default isIpad;